import React, { useEffect, useState } from "react"
import { Card, CardContent, Typography, Avatar, Box, Button, TextField, Stack } from "@mui/material"
import useTranslationSharie from "../hooks/Language/useTranslation"
import CaptureVideoImage from "../hooks/Utils/CaptureVideoImage"
import { useApiService } from "../hooks/Api/useApiService"

const BusinessCard = ({ user_name }) => {
  const t = useTranslationSharie()
  const [editing, setEditing] = useState(false)
  const [image, setImage] = useState(null)
  const { postData } = useApiService()
  const initial_data = {
    name: "John Doe",
    title: "Software Engineer",
    phone: "+1 234 567 890",
    email: "john.doe@example.com",
    company: "Example Corp",
    image: null,
    bgColor: "#f5f5f5",
    accentColor: "#1976d2",
  }
  const [data, setData] = useState(initial_data)

  useEffect(() => {
    postData("sharie/getbusinesscard", { user_name: user_name }).then((data) => {
      if (data?.businesscard) {
        setData((prev) => ({ ...prev, ...data?.businesscard }))
      }
    })
  }, [])

  const handleChange = (field) => (e) => {
    setData((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleCancel = () => {
    setData(initial_data)
    setEditing(false)
  }

  const handleSave = () => {
    // you could call an API or lift the data up here
    postData("sharie/addorupdatebusinesscard", {
      user_name: localStorage.getItem("user"),
      data: {
        name: data.name,
        title: data.title,
        phone: data.phone,
        email: data.email,
        company: data.company,
        image: image,
      },
    }).then((data) => {
      setEditing(false)
    })
  }

  return (
    <Card
      sx={{
        display: "flex",
        width: 400,
        minHeight: 200,
        borderRadius: 3,
        backgroundColor: "background.paper",
        boxShadow: 4,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          backgroundColor: data.accentColor,
          width: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        }}
      >
        {!editing ? (
          <Avatar
            src={data.image || image}
            sx={{ width: 64, height: 64, bgcolor: "#fff", color: data.accentColor }}
          ></Avatar>
        ) : (
          <CaptureVideoImage image={image} setImage={setImage} />
        )}
      </Box>

      <CardContent sx={{ flex: 1, p: 2 }}>
        {!editing ? (
          <>
            <Typography variant='h6' fontWeight={600}>
              {data.name}
            </Typography>
            <Typography variant='subtitle2' color='text.secondary' gutterBottom>
              {data.title}
            </Typography>
            <Typography variant='body2'>📞 {data.phone}</Typography>
            <Typography variant='body2'>✉️ {data.email}</Typography>
            <Typography variant='body2' color='text.secondary' mt={1}>
              {data.company}
            </Typography>
            {user_name === localStorage.getItem("user") && (
              <Button variant='text' size='small' sx={{ mt: 1 }} onClick={() => setEditing(true)}>
                {t("Edit Business Card")}
              </Button>
            )}
          </>
        ) : (
          <Stack spacing={1} bgcolor='background.paper'>
            <TextField
              fullWidth
              label={t("Name")}
              value={data.name}
              onChange={handleChange("name")}
            />
            <TextField
              fullWidth
              label={t("Title")}
              value={data.title}
              onChange={handleChange("title")}
            />
            <TextField
              fullWidth
              label={t("Phone")}
              value={data.phone}
              onChange={handleChange("phone")}
            />
            <TextField
              fullWidth
              label={t("Email")}
              value={data.email}
              onChange={handleChange("email")}
            />
            <TextField
              fullWidth
              label={t("Company")}
              value={data.company}
              onChange={handleChange("company")}
            />
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              <Button variant='contained' size='small' onClick={handleSave}>
                {t("Save")}
              </Button>
              <Button variant='outlined' color={"secondary"} size='small' onClick={handleCancel}>
                {t("Cancel")}
              </Button>
            </Box>
          </Stack>
        )}
      </CardContent>
    </Card>
  )
}

export default BusinessCard
